import React from "react";
import { BILLING_DISPLAY_FORMAT } from "repoV2/features/Listing/Listing.constants";
import { ICheckoutCreatorDetails } from "../utils/apis/CreatorDetailsApi/ICreatorDetailsApi.interface";

export interface ICheckoutPriceDetailsContext {
    gstSummaryType: number;
    isInternationalCreator: boolean;
}

export interface ICheckoutPriceDetailsContextProvider {
    initialData: {
        creatorDetails: ICheckoutCreatorDetails;
        children?: JSX.Element | JSX.Element[];
    };
}

const initial_state: ICheckoutPriceDetailsContext = {
    gstSummaryType: BILLING_DISPLAY_FORMAT.DEFAULT_SHOW_ALL,
    isInternationalCreator: false,
};

const CheckoutPriceDetailsContext = React.createContext(initial_state);

const CheckoutPriceDetailsContextProvider: React.FC<ICheckoutPriceDetailsContextProvider> =
    props => {
        const {
            initialData: { creatorDetails },
            children,
        } = props;

        const {
            gst_summary_type:
                gstSummaryType = BILLING_DISPLAY_FORMAT.DEFAULT_SHOW_ALL,
            is_international_creator: isInternationalCreator = false,
        } = creatorDetails;

        return (
            <CheckoutPriceDetailsContext.Provider
                value={{
                    gstSummaryType,
                    isInternationalCreator,
                }}
            >
                {children}
            </CheckoutPriceDetailsContext.Provider>
        );
    };

export const useCheckoutPriceDetailsContext = () =>
    React.useContext(CheckoutPriceDetailsContext);

export default CheckoutPriceDetailsContextProvider;
